import useEventProgram from "../../hooks/useEventProgram";
import AlphabetFilter from "../../../AlphabetFilter";
import { useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import {Link} from "react-router-dom";

const contentExtractor = (item) => item.name[0].toLowerCase();

export default function Reports({ id }) {
    const [programData] = useEventProgram(id);
    const [filter, setFilter] = useState({
        byLetter: '',
    });
    const updateLetterFilter = (value) => {
        setFilter({...filter, byLetter: value});
    }

    if (!programData) {
        return null;
    }

    const reports = Object.values(programData.reports);
    const reportsList = reports.filter(item => {
        return (filter.byLetter === '' || item.name[0].toLowerCase() === filter.byLetter.toLowerCase());
    });

    return (
        <div className="tab-panel active" id="reports">
            <div className="reports-list">
                <AlphabetFilter
                    list={reports}
                    contentExtractor={contentExtractor}
                    notifyChange={updateLetterFilter}
                />
                <div>
                    {
                        reportsList.map(report =>
                            <Link to={`/conference/${id}/reports/${report.id}`} key={uuidv4()} className="report-name-block">
                                <h6>{report.name}</h6>
                                <p>
                                    {
                                        report.authors.map(
                                            (author, index) =>
                                                <>
                                                    <span className="js-author-link">
                                                        { author.lastName } { author.firstName } { author.middleName }
                                                    </span>
                                                    {
                                                        report.authors.length > 1 && report.authors.length !== index + 1 && ', '
                                                    }
                                                </>
                                        )
                                    }
                                </p>
                            </Link>
                        )
                    }
                </div>
            </div>
        </div>

    )
}
